<template>
  <div class="tabulka__bg">
    <div :class="BackgroundImage"></div>
  </div>
</template>

<script>
export default {
  name: "TabulkaBackground",
  props: {
    BackgroundImage: String,
  },
};
</script>